import { useQuery } from "@tanstack/react-query";
import { blogService } from "@/services/blog";
import type { ListPublishedParams } from "@/shared/blog/blogService.contract";
import { blogKeys } from "./queryKeys";

/** Lista pública paginada de posts publicados (blog). */
export const usePublishedPosts = (params?: ListPublishedParams) =>
  useQuery({
    queryKey: blogKeys.publishedList(params),
    queryFn: () => blogService.listPublished(params),
  });
